<div class="d-flex ngx-mat-paginator-container">
  <div class="d-flex flex-column flex-md-row justify-content-end align-items-center w-100">
    <div class="d-flex pagesize align-items-baseline">
      <div class="d-flex mr-2 ngx-mat-paginator-label">Rows per page</div>
      <div class="d-flex select">
        <mat-form-field class="w-100">
          <mat-select [(value)]="pageSizeSelected" (selectionChange)="onChangePageSizeSelected($event)">
            <mat-option *ngFor="let item of pageSizeOptions" [value]="item">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="d-flex align-items-baseline mx-md-4 mx-ms-0 info">
      <div class="ngx-mat-paginator-label mb-3 mb-md-0">
        {{showFrom}}-{{showTo}} of {{totalElements}}
      </div>
    </div>
    <div class="d-flex align-items-baseline mb-3 mb-md-0 actions">
      <div class="d-flex previous">
        <button mat-icon-button (click)="onPreviousPage()" [disabled]="pageIndex === 0">
          <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
      </div>
      <div class="d-flex mx-2 navigate-generate">
        <ng-container *ngFor="let page of pages">
          <button *ngIf="page.id === pageIndex" (click)="onPage(page.id)" mat-mini-fab>{{page.label}}</button>
          <button *ngIf="page.id !== pageIndex" (click)="onPage(page.id)" [disabled]="page.disabled" mat-icon-button>{{page.label}}</button>
        </ng-container>
      </div>
      <div class="d-flex next">
        <button mat-icon-button (click)="onNextPage()" [disabled]="pageIndex === totalPage - 1">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
